import { useState } from 'react';
import { Link } from 'react-router-dom';
import { passwordResetSchema } from '@shared/schemas';
import { authUtils } from '@/hooks/useAuth';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);

    const validation = passwordResetSchema.safeParse({ email });
    if (!validation.success) {
      setError(validation.error.errors[0].message);
      return;
    }

    try {
      await authUtils.resetPassword(email);
      setSent(true);
    } catch {
      setError('Ein Fehler ist aufgetreten. Bitte prufen Sie die E-Mail-Adresse.');
    }
  }

  if (sent) {
    return (
      <div className="max-w-md mx-auto py-12">
        <h1 className="text-2xl font-serif mb-4">E-Mail gesendet</h1>
        <p className="text-text-secondary mb-4">
          Wir haben Ihnen eine E-Mail mit einem Link zur Passwort-Zurucksetzung gesendet.
        </p>
        <Link to="/anmelden" className="btn-primary">Zuruck zur Anmeldung</Link>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto py-12">
      <h1 className="text-2xl font-serif mb-6">Passwort vergessen</h1>

      {error && (
        <div className="mb-4 p-3 bg-status-danger/10 border border-status-danger/20 text-status-danger text-sm rounded-sm">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="email" className="block text-sm font-medium mb-1">E-Mail</label>
          <input id="email" type="email" className="input-field" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <button type="submit" className="btn-primary">Link senden</button>
      </form>
    </div>
  );
}
